<template>
	<div class="user_oute">

		<!--  -->
		<div class="head_blist FlexRow">
			
			<div class="blist_api" @click="gotoApi" v-if="aipshow">
				API
			</div>
			
			<el-badge :is-dot="false" class="item">
				<el-dropdown>
					<div class="head_btn FlexRow">
						<img src="~assets/img/aggregate/head1-1.png" alt="">
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="1">
							我要反馈
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-badge>
			<el-badge :is-dot="false" class="item">
				<div class="head_btn FlexRow">
					<img src="~assets/img/aggregate/head1-2.png" alt="">
				</div>
			</el-badge>
			<el-badge :is-dot="true" class="item">
				<el-popover trigger="click"  popper-class="user_pover_not">
					<template slot="reference">
						<div class="head_btn FlexRow">
							<img src="~assets/img/aggregate/head1-3.png" alt="">
						</div>
					</template>
					
					<!-- <div class="notice_Box">
						<div class="notice_head">
							<div class="tit">
								消息通知
							</div>
						</div>
						
						<div class="notice_container">
							<div class="notice_item" v-for="(item1, index1) in noticelist">
								<div class="notice_title Flexalign">
									{{item1.typeTitle}}
								</div>
								<div class="notice_content Flexalign" @click="clicknotice(item2)" v-for="(item2, index2) in item1.list">
									<div class="infos_box Flexalign">
										<div class="infos_txt Singlerow">
											{{item2.title}}
										</div>
										<div class="important FlexRow" v-if="item2.important">
											重要
										</div>
									</div>
									<div class="info_time" v-if="item2.time">
										【{{item2.time}}】
									</div>
								</div>
							
							</div>
						</div>
						
					</div> -->
				
				</el-popover>
				
			</el-badge>
		</div>
		<!--  -->
		<!--  -->
		<el-popover trigger="click" popper-class="user_pover_not" :visible-arrow="false">
			<template slot="reference">
				<div class="uesr_Boxs">
					<div class="uesr_img">
						<img :src="user_info.head_image" alt="" v-if="user_info.head_image">
						<img :src="urlhead + '/head1-4.png'" v-else>
					</div>
					<div class="user_name danhang">
						{{user_info.member_name || ''}}
					</div>
					<div class="icons">
						<i class="el-icon-arrow-down"></i>
					</div>
				</div>
			</template>
			<div class="popover_box">
				<div class="user_pop Flex_algin" @click="gotouser">
					<div class="img_box">
						<img :src="user_info.head_image" alt="" v-if="user_info.head_image">
						<img :src="urlhead + '/head1-4.png'" v-else>
					</div>
					<div class="infos">
						<div class="info_name Flex_algin">
							<div class="u_name danhang">
								{{user_info.member_name || ''}}
							</div>
							<div class="icons">
								<i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<div class="info_qyname danhang">
							{{user_info.merchant_name || ''}}
						</div>
					</div>
				</div>

				<div class="edition" v-if="current_objstore">
					<div class="edition_tit">
						{{current_objstore.pro_version || ''}}
					</div>
					<div class="txt">
						账号用户数
						<span>{{user_count || 0}}</span>
						个 | 可用
						<span> {{available || 0}} </span> 个
					</div>
					<div class="txt">
						剩余
						<span>
							{{surplus_num || 0}}
						</span>
						天（{{current_objstore.prj_expiry || ''}}）到期
					</div>
				</div>

				<div class="switch_box">

					<el-popover trigger="hover" placement="left-start" popper-class="user_pover_not" :visible-arrow="false">
						<template slot="reference">
							<div class="switch_btn Flexbetween">
								<div class="tit">
									切换项目
								</div>
								<div class="icon_txt Flex_algin">
									切换
									<i class="el-icon-arrow-right"></i>
								</div>
							</div>
						</template>
						<div class="switch_pos">

							<div class="xm_item Flex_algin" @click="Switchitems(item)"
								v-for="(item, index) in storeList" :class="{'isActive': item.id == currentstoreid}">
								<div class="xm_icon">
									<img :src="item.prj_logo" alt="" v-if="item.prj_logo">
									<img src="~assets/img/aggregate/project1-2.png" alt="" v-else>
								</div>
								<div class="xm_name danhang">
									{{item.prj_name || ''}}
								</div>
							</div>

							<div class="xm_item bortop Flex_algin">
								<div class="addicon">
									<i class="el-icon-plus"></i>
								</div>
								<div class="addspan">
									创建新项目
								</div>
							</div>
						</div>

					</el-popover>

				</div>

				<div class="switch_box">
					<div class="switch_btn Flexbetween">
						<div class="tit">
							帮助中心
						</div>

					</div>
				</div>
				<div class="switch_box">
					<div class="switch_btn Flexbetween">
						<div class="tit">
							联系我们
						</div>
					</div>
				</div>
				<div class="switch_box">
					<div class="switch_btn Flexbetween" @click="gotouser">
						<div class="tit">
							个人资料
						</div>
					</div>
				</div>
				<div class="switch_box bortop" @click="fn_logintiOut">
					<div class="switch_btn Flexbetween ">
						<div class="tit">
							退出登录
						</div>
					</div>
				</div>


			</div>


		</el-popover>
		<!--  -->



	</div>
</template>

<script>
	import {
		loginOut,
		getLoginUserInfo,
		getStoreInfo,
		changeStore,
	} from 'network/hk_storeinfo'
	import {
		getQwConfig
	} from 'network/hk_wechat'

	import {
		getStoreSystemSetting
	} from 'network/hk_setup'
	
	import {
		
		handlereq,
		alertMess,
		try_catch,
		fn_getother,
		getStoreConfig,
	} from 'network/kh_public'
	

	export default {
		name: "User",
		data() {
			return { 
				aipshow: false,
				
				
				user_info: {},
				storeList: [],
				current_objstore: '',
				currentstoreid: '',

				surplus_num: 0,
				available: 0,
				user_count: 0,
				
				noticelist: [
					{
						typeTitle: '系统通知',
						list: [ 
							{
								title: '企微任务宝7天免费试用',
								time: '2021-07-08',
								important: false,
							},
						],
					},
					{
						typeTitle: 'API更新通知',
						list: [
							{
								title: '【重要】关于【企业微信账号ID升级】的重要通知',
								time: '2021-11-30',
								important: true,
							},
							{
								title: 'openapi接口更新：获取群聊详情',
								time: '2021-11-16',
								important: false,
							},
							{
								title: '重大更新：openapi使用条款',
								time: '2021-11-16',
								important: true,
							},
						],
					},
				],
				
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/hkt_home/aggregate',
			
			}
		},
		created() {
			// 用户信息
			this.getLoginUsers()
			
			this.aipshow = fn_getother('OpenAPI')


			
		},
		
		
		methods: {
		
			
			fn_getStoreCon(){
				// 获取项目配置
				getStoreConfig().then(res => {
					if(res) {
						if (res.code === 10000) {
							let obj = res.result
							if(obj) {
								// 自定义 页面每页列表数量（50页/条）| 自定义页面数据排序
								let custom_list = obj.custom_list || '';
								localStorage.setItem('custom_list', custom_list);
								// window.location.href = 'https://scrm.51kuaiding.com/scrm'
							}
						}
						
						
					}
				})
			},
			// 系统设置
			fn_getStoreSyste() {
				getStoreSystemSetting().then(res => {
					if (handlereq(res)) {
						let obj = res.result
						if(obj) {
							this.available = obj.user_count - obj.member_count
							this.user_count = obj.user_count
						}
						
						if (obj.kd_store_config) {
							let currentobj = obj.kd_store_config
							let {
								prj_expiry,
								
							} = currentobj
							this.surplus_num = this.surplusDay(prj_expiry)
							this.current_objstore = currentobj
							
							
						
							let other_function = obj.kd_store_config.other_function || []
							localStorage.setItem('other_function', JSON.stringify(other_function));
							
							this.aipshow = fn_getother('OpenAPI')
						
						}
			
					}
				})
			},
			
			clicknotice(item){
				this.$router.push({
					path: '/notice',
				})
			},
			gotoApi(){
				if(this.$route.path != '/open_platform/apiman') {
					this.$router.push({
						path: '/open_platform/apiman',
					})
				}
				else {
					this.$router.go(0)
				}
			},
			
			gotouser(){
				this.$router.push({
					path: '/set_up/user',
				})
			},		
		
			Switchitems(value) {
				this.$cookies.remove("KDPID", null, '.51kuaiding.com');
				localStorage.removeItem('user_info')
				this.fn_changexm(value.id)
			},
			fn_changexm(id) {
				changeStore(id).then(res => {
					if (handlereq(res)) {
						alertMess('切换成功')
						
						this.$cookies.remove("KDPID", null, '.51kuaiding.com');
						
						this.fn_getStoreSyste()
						this.fn_getStoreCon()
						this.getLoginUsers()
						setTimeout(()=>{
							this.$router.push({
								path: '/route',
								query: {
									path: '/home'
								}
							})
						}, 500)
						// 
					}
				})
			},


			surplusDay(str) {
				if (str) {
					const setTime = new Date(str);
					const nowTime = new Date();
					const restSec = setTime.getTime() - nowTime.getTime();
					const day = parseInt(restSec / (60 * 60 * 24 * 1000));
					return day
				} else {
					return ''
				}
			},



			
			
			
			// 退出登陆
			fn_logintiOut() {
				
				this.$cookies.remove('MERCHANT_STATE_KEY')
				loginOut().then(res => {
					if (res.code === 10000) {
						this.fn_remove()
					}
					else if(res.code === 10001) {
						alert(res.message)
						if(res.message == '项目已过期') {
							this.fn_remove()
							// localStorage.removeItem('member_id')
							// localStorage.removeItem('member_name')
							// localStorage.removeItem('jurisdiction')
							// localStorage.removeItem('user_info')
							// localStorage.removeItem('store_id')
							// localStorage.clear()
							// window.location.href = "https://i.51kuaiding.com/hktlogin"
						}
					}
				})
			},
			fn_remove() {
				this.$cookies.remove("MERCHANT_STATE_KEY", null, '.51kuaiding.com');
				this.$cookies.remove("MERCHANT_ACCOUNT_USERNAME", null, '.51kuaiding.com');
				this.$cookies.remove("MERCHANT_USERNAME", null, '.51kuaiding.com');
				localStorage.clear()
				window.location.href = "https://i.51kuaiding.com/hktlogin"
				// this.$cookies.set('KDTP','HKT',60 * 60,'/','.51kuaiding.com')
				// localStorage.removeItem('member_id')
				// localStorage.removeItem('member_name')
				// localStorage.removeItem('jurisdiction')
				// localStorage.removeItem('store_id')
				
				
			},
			// 用户信息 
			getLoginUsers() {
				let local_info = localStorage.user_info;
				if(local_info && typeof(local_info) == 'string') {
					this.user_info = JSON.parse(local_info) 
					// 获取项目列表
					this.get_xmlist()
				}
				else {
					getLoginUserInfo().then(res => {
						if (handlereq(res)) {
							let obj = res.result
							this.user_info = obj
							this.$store.commit('setMemberName', obj.member_name)
							this.$store.commit('setMemberId', obj.member_id) 
							
							localStorage.setItem('jurisdiction', obj.power_id);
							localStorage.setItem('data_power', obj.data_power);
							localStorage.setItem('field_power', obj.field_power);
							let user_info = JSON.stringify(obj)
							localStorage.setItem('user_info', user_info);
							localStorage.setItem('user_info', user_info);
							// 获取项目列表
							this.get_xmlist()
						}
					})
				}
			},
			// 获取项目列表
			get_xmlist() {
				getStoreInfo().then(res => {
					if (res.code == 10000) {
						let obj = res.result
						let id = obj.current_store * 1
						this.currentstoreid = id
						this.$store.commit('setStoreId', id)
						localStorage.setItem('store_id', id);
						this.storeList = obj.data
						this.fn_getStoreSyste()
						// 企业微信信息
						this.fngetQwConfiger()
					}
				})
			},
			
			// 企业微信信息
			fngetQwConfiger() {
				getQwConfig().then(res => {
					if (handlereq(res)) {
						if (res.result) {
							localStorage.setItem('is_binding', 1);
						} else {
							localStorage.setItem('is_binding', 0);
						}
					}
				})
			},

			
		


		// end
		}
	}
</script>

<style scoped lang="scss">
	.notice_Box{
		width: 460px;
		.notice_head{
			
			width: 100%;
			border-bottom: 1px solid #e9ebf3;
			padding: 13px 0 13px 16px;
			.tit{
			    color: rgba(0,0,0,.65);
			    font-size: 16px;
			    font-weight: 600;
			    line-height: 20px;
			}
		}
		.notice_container{
			padding-bottom: 50px;
			width: 100%;
			.notice_item{
				padding:0 16px;
				width: 100%;
				.notice_title::before{
					display: inline-block;
				    background-color: #1890ff;
				    content: "";
				    height: 14px;
				    margin-right: 16px;
				    width: 4px;	
				}
				.notice_title{
				    margin-top: 16px;
					color: rgba(0,0,0,.65);
					font-size: 14px;
					
				}
				.notice_content{
					border-bottom: 1px dashed #e9ebf3;
				    overflow: hidden;
				    padding: 12px 0;
				    position: relative;
					width: 100%;
					.infos_box::before{
						content: '';
						background-color: #eee;
					    border-radius: 50%;
					    display: inline-block;
					    height: 4px;
					    margin: 0 7px;
					    overflow: hidden;
					    width: 4px;	
					}
					.infos_box{
						flex: 1;
						.infos_txt:hover{
							color:var(--themeColors);
						}
						.infos_txt{
							color: rgba(0,0,0,.65);
						    font-size: 13px;
						    max-width: 277px;
							cursor: pointer;
						}
						.important{
							border-radius: 2px;
						    color: #fff;
						    font-size: 10px;
						    font-weight: 600;
						    height: 15px;
						    margin-left: 6px;
						    right: -3px;
						    text-align: center;
						    top: 15px;
						    width: 32px;
							background: linear-gradient(137deg,#c691ff,#9d60f2)!important;
						}
					} 
					
					.info_time{
						color: #666;
					    font-size: 12px;
					    font-weight: 400;
					    padding: 0;
					    white-space: nowrap;	
					}
				}
			
			}
			
		}
	}
	  
	   
	  
	
	.blist_api:hover{
		color: var(--themeColors);
	}
	.blist_api{
		cursor: pointer;
		font-size: 16px;
		color: #3a3a3f;
	}
	.feedback{
		padding: 10px;
		.feeditem{
			
		}
	}
	.popover_box {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0 ,0.1);
		width: 300px;
		border-radius: 4px;
		// background: rgba(255, 255, 255, 1);


		.user_pop {
			padding: 0 23px;
			width: 100%;
			height: 85px;
			// background-color: pink;

			background: url(https://scrm.51kuaiding.com/scrm/hktxcx/hkt_home/aggregate/project1-1.png) no-repeat;
			background-size: cover;
			overflow: hidden;

			.img_box {
				>img {
					width: 46px;
					height: 46px;
					display: block;
					border-radius: 100%;
					box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .4);
				}
			}

			.infos {
				margin-left: 8px;
				cursor: pointer;

				.info_name {
					.u_name {
						max-width: 180px;
						font-size: 14px;
						color: rgba(255, 255, 255, 1);
						margin-right: 8px;
					}

					.icons {
						i {
							color: rgba(255, 255, 255, 1);
						}
					}
				}

				.info_qyname {
					margin-top: 8px;
					width: 180px;
					font-size: 14px;
					color: rgba(255, 255, 255, 1);
				}
			}
		}

		.edition {
			width: 100%;
			padding: 20px 23px;
			border-bottom: solid 1px rgba(241, 242, 244, 1);

			.edition_tit {
				font-size: 16px;
				margin-bottom: 6px;
				color: rgba(51, 51, 51, 1);
			}

			.txt:last-of-type {
				margin-bottom: 0px;
			}

			.txt {
				margin-bottom: 6px;
				font-size: 12px;
				color: rgba(102, 102, 102, 1);

				span {
					color: rgba(42, 117, 234, 1);
					display: inline-block;
					margin: 0 3px;
				}
			}
		}

		.switch_box.bortop {
			border-top: solid 1px rgba(241, 242, 244, 1);
		}

		.switch_box {
			width: 100%;
			padding: 4px 5px;

			.switch_btn:hover {
				background: rgba(241, 244, 255, 1);

			}

			.switch_btn {
				padding: 0 7px 0 19px;
				cursor: pointer;
				transition: all .3s;
				width: 100%;
				height: 40px;
				border-radius: 3px;
				position: relative;


				.tit {
					font-size: 14px;
					color: rgba(51, 51, 51, 1);
				}

				.icon_txt {
					font-size: 12px;
					color: rgba(153, 153, 153, 1);

					i {
						margin-left: 14px;
						display: inline-block;
						color: rgba(153, 153, 153, 1);
					}
				}
			}



		}

	}

	.switch_pos {
		width: 210px;
		padding: 8px 0;
		border-radius: 4px;
		background: rgba(255, 255, 255, 1);

		// box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.14);
		.xm_item:hover {
			background: rgba(241, 244, 255, 1);

			.xm_name {
				color: rgba(42, 117, 234, 1);
			}
		}

		.xm_item.bortop {
			border-top: solid 1px rgba(241, 242, 244, 1);
		}

		.xm_item.isActive {
			background: rgba(241, 244, 255, 1);

			.xm_name {
				color: rgba(42, 117, 234, 1);
			}

		}

		.xm_item {
			cursor: pointer;
			transition: all .3s;
			height: 50px;
			padding: 0 11px;

			.xm_icon {
				width: 31px;
				height: 31px;
				border-radius: 4px;
				margin-right: 6px;

				img {
					width: 100%;
					height: 100%;
					display: block;
				}
			}

			.xm_name {
				color: rgba(51, 51, 51, 1);
				width: 138px;
				font-size: 14px;
			}

			.addicon {
				i {
					color: rgba(42, 117, 234, 1);
				}

				margin-right: 8px;
			}

			.addspan {
				color: rgba(42, 117, 234, 1);
			}
		}

	}


	.Flex_algin {
		display: flex;
		align-items: center;

	}

	.FlexRow {
		display: flex;
		align-items: center;
		justify-content: center;

	}

	.Flexbetween {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.head_blist {
		margin-right: 20px;

		.head_btn {
			margin-left: 15px;
			width: 24px;
			height: 24px;
			border-radius: 3px;
			cursor: pointer;
			transition: all .3s;

			img {
				width: 14px;
				height: 16px;
				display: block;
			}
		}

		.head_btn:hover {

			background: rgba(235, 235, 235, 1);
		}
	}



	.uesr_Boxs {
		display: flex;
		align-items: center;
		cursor: pointer;

		.uesr_img {
			height: 32px;
			width: 32px;

			>img {
				height: 100%;
				width: 100%;
				border-radius: 100%;
				display: block;
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .4);
			}

		}

		.user_name {
			width: 50px;
			font-size: 14px;
			color: rgba(95, 95, 95, 1);
			margin: 0 8px;
		}
	}

	.user_oute {
		display: flex;
		align-items: center;


	}
</style>
